import SuperRepository from '../superRepository'

export default new (class PartnerInfoRepository extends SuperRepository {
    baseUri() {
        return 'partner_info'
    }
    checkDuplicate = id => this.httpClient().get(`${this.baseUri()}/${id}/check_duplicate`)
})()
